<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ purpose === 'template' ? 'Select Template Permissions' : 'Select Permissions' }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog without changing the selected permissions."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="m-0 pt-3">

  <div class="alert alert-info" *ngIf="!isLoading && purpose !== 'template'">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    Roles that have <strong>any</strong> of the selected permissions will be listed. Leave the
    selection empty to list roles with any permissions.
  </div>

  <div class="selector-controls">
    <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
      <mat-icon matPrefix>search</mat-icon>
      <mat-label>Search features...</mat-label>
      <input
        matInput
        placeholder="Type to filter features..."
        [(ngModel)]="searchText"
        name="search"
        type="text"
        (ngModelChange)="onFilterFeatures()"
        matTooltip="Filter the list by category, feature or permission name.">
      <button mat-icon-button matSuffix *ngIf="searchText" (click)="clearSearch()" type="button" matTooltip="Clear the search.">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>

    <div class="selected-summary">
      <span class="selected-count">{{ getSelectedCount() }}</span>
      <span class="selected-label">selected</span>
      <button
        mat-stroked-button
        type="button"
        *ngIf="getSelectedCount() > 0"
        (click)="onClearSelection()"
        matTooltip="Deselect all permissions.">
        <mat-icon>clear_all</mat-icon> Clear
      </button>
    </div>
  </div>

  <div class="loading-container" *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <p class="loading-text">Loading permissions...</p>
  </div>

  <div class="categories-container" *ngIf="!isLoading">
    <mat-accordion multi *ngIf="getSortedCategoryKeys().length > 0; else noResults">
      <mat-expansion-panel
        *ngFor="let categoryKey of getSortedCategoryKeys()"
        [expanded]="filtered_categories[categoryKey].expanded"
        (opened)="filtered_categories[categoryKey].expanded = true"
        (closed)="filtered_categories[categoryKey].expanded = false"
        class="category-panel">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="category-header-content">
              <mat-icon class="category-icon">{{ filtered_categories[categoryKey].icon }}</mat-icon>
              <span class="category-name">{{ categoryKey }}</span>
              <span class="category-badge" [class.has-permissions]="getCategoryCount(categoryKey).selected > 0">
                {{ getCategoryCount(categoryKey).selected }}/{{ getCategoryCount(categoryKey).total }}
              </span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="features-container">
          <table class="features-table">
            <thead>
              <tr>
                <th class="feature-name-col">Feature</th>
                <th class="permission-col" *ngFor="let action of availableActions">
                  <mat-icon>{{ getIconForAction(action) }}</mat-icon>
                  <span>{{ action | titlecase }}</span>
                </th>
                <th class="quick-actions-col">Quick Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let feature of filtered_categories[categoryKey].features | keyvalue" class="feature-row">
                <td class="feature-name-cell">
                  <span class="feature-name">{{ feature.key }}</span>
                  <ng-container *ngIf="getFeatureDescription(feature.value.rbac_permissions) as featureDescription">
                    <button
                      type="button"
                      class="rbac-feature-info-btn"
                      [attr.aria-label]="'What does ' + feature.key + ' cover?'"
                      [matTooltip]="featureDescription"
                      matTooltipPosition="above"
                      matTooltipClass="rbac-feature-tooltip"
                      [matTooltipShowDelay]="300"
                      (click)="$event.stopPropagation()">
                      <mat-icon aria-hidden="true">info_outline</mat-icon>
                    </button>
                  </ng-container>
                </td>
                <td class="permission-cell" *ngFor="let action of availableActions">
                  <ng-container *ngIf="getPermissionForAction(feature.value.rbac_permissions, action) as permission; else noPermission">
                    <mat-checkbox
                      [(ngModel)]="permission.checked"
                      [name]="'rbac_permission_' + permission.id"
                      [matTooltip]="getPermissionTooltip(permission)">
                    </mat-checkbox>
                  </ng-container>
                  <ng-template #noPermission>
                    <span class="no-permission">-</span>
                  </ng-template>
                </td>
                <td class="quick-actions-cell">
                  <button
                    mat-icon-button
                    type="button"
                    (click)="onSelectFeature(feature.value.rbac_permissions)"
                    matTooltip="Select all permissions for this feature.">
                    <mat-icon>done_all</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    type="button"
                    (click)="onDeselectFeature(feature.value.rbac_permissions)"
                    matTooltip="Deselect all permissions for this feature.">
                    <mat-icon>block</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <ng-template #noResults>
      <div class="no-results-container">
        <mat-icon class="no-results-icon">search_off</mat-icon>
        <p class="no-results-text">No features found matching "{{ searchText }}"</p>
        <button mat-stroked-button type="button" (click)="clearSearch()">Clear Search</button>
      </div>
    </ng-template>
  </div>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <button
    class="my-2 mx-1"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSaveAndClose()"
    matTooltip="Apply the selected permissions.">
    Select &amp; Close
  </button>
</mat-dialog-actions>
